import { isMissing } from "./missing";
import type { ReportValue } from "./types";

/** Numeric cells preserve blanks as missing and reject booleans. */
export const reportNumber = (value: ReportValue | undefined): number | null => {
  if (isMissing(value) || typeof value === "boolean") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};
